import React, { useEffect } from "react";
import { generatePath, useNavigate } from "react-router";
import { isGroupAdmin, isSuperOrBrandAdmin } from "../../utility";
import { connect } from "react-redux";
import {
  groupAdminPath,
  managerAdminPath,
  viewPathConstants,
  NAVIGATION_DELAYS_MS,
} from "../../../constants";

const FromSurveyFeedbackToInbox = (props) => {
  const {
    authentication: { user },
  } = props;
  const navigate = useNavigate();
  const groupAdmin = isGroupAdmin();
  const superOrBrandAdmin = isSuperOrBrandAdmin();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const pathToNavigate = superOrBrandAdmin
        ? viewPathConstants.STORES
        : groupAdmin
          ? generatePath(groupAdminPath.DASHBOARD_BY_GROUP_ADMIN, {
              groupId: String(user.groupId),
            })
          : generatePath(managerAdminPath.DASHBOARD_BY_MANAGER_ADMIN, {
              managerId: String(user.id),
            });

      navigate(pathToNavigate, {
        replace: true,
      });
    }, NAVIGATION_DELAYS_MS.INBOX_UNAVAILABLE_REDIRECT);

    // Stop the redirect when this screen is no longer shown.
    return () => clearTimeout(timeoutId);
  }, [groupAdmin, superOrBrandAdmin, user.groupId, user.id, navigate]);

  return (
    <div className="w-100 vh-100 d-flex justify-content-center align-items-center">
      <div className="bg-secondary bg-opacity-10 rounded-4 p-5">
        <h5 className="fw-bold">Inbox Unavailable!</h5>
        <p className="pt-3">
          Hold on! The Survey Inbox feature is disabled for your brand.
          <br /> You’ll be redirected to the default page shortly.
        </p>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  authentication: state.authentication,
});

export default connect(mapStateToProps, null)(FromSurveyFeedbackToInbox);
